import { c as _c } from "react/compiler-runtime";
import { translate, getActiveLang } from '@openclassrooms/translations';
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import { isoDateToString } from '@openclassrooms/utils/date';
import { styled } from '@classify/react-core-components/styles';
import type { CourseTeacher, CourseCreator } from '@openclassrooms/sdk-web';
import Licenses from './Licenses';
import Teachers from './Teachers';
import Creators from './Creators';
interface CourseCreditsProps {
  teachers: Array<CourseTeacher>;
  creators: Array<CourseCreator>;
  license: string;
  updatedAt: string;
}
const Title = styled(Typography)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  borderBottom: `1px solid ${palette.divider}`,
  margin: spacing(0, 0, 3, 0),
  paddingBottom: spacing(1)
}));
const Separator = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  width: 1,
  backgroundColor: palette.divider,
  margin: spacing(0, 6)
}));
const Credits = t0 => {
  const $ = _c(69);
  const {
    teachers,
    creators,
    license,
    updatedAt
  } = t0;
  let T0;
  let T1;
  let T2;
  let T3;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== creators || $[1] !== teachers || $[2] !== updatedAt) {
    const lang = getActiveLang();
    const updatedAtString = isoDateToString(updatedAt, lang, {
      day: lang === "fr" ? "2-digit" : "numeric",
      month: lang === "fr" ? "2-digit" : "numeric",
      year: "numeric"
    });
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Title component="h2" variant="h3">{translate("course.credits.title")}</Title>;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    let t15;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = {
        mt: {
          sm: 3,
          xs: 6
        }
      };
      $[22] = t15;
    } else {
      t15 = $[22];
    }
    let t16;
    if ($[23] !== teachers.length) {
      t16 = translate("course.teachers.title", {}, teachers.length);
      $[23] = teachers.length;
      $[24] = t16;
    } else {
      t16 = $[24];
    }
    let t17;
    if ($[25] !== t16) {
      t17 = <Typography variant="h5" component="h3">{t16}</Typography>;
      $[25] = t16;
      $[26] = t17;
    } else {
      t17 = $[26];
    }
    let t18;
    if ($[27] !== teachers) {
      t18 = <Teachers teachers={teachers} />;
      $[27] = teachers;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    if ($[29] !== t17 || $[30] !== t18) {
      t14 = <Stack direction="column" gap={2} sx={t15}>{t17}{t18}</Stack>;
      $[29] = t17;
      $[30] = t18;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    T3 = Stack;
    t10 = 2;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        mt: {
          sm: 9,
          xs: 6
        }
      };
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Typography variant="h5" component="h3">{translate("course.teachers.course_creators.title")}</Typography>;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    T2 = Stack;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        xs: "column",
        sm: "row"
      };
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t7 = 2;
    if ($[35] !== creators) {
      t8 = <Creators creators={creators} />;
      $[35] = creators;
      $[36] = t8;
    } else {
      t8 = $[36];
    }
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Separator />;
      $[37] = t9;
    } else {
      t9 = $[37];
    }
    T1 = Stack;
    t3 = "column";
    t4 = "center";
    t5 = 2;
    T0 = Typography;
    t1 = "subheading";
    t2 = translate("course.last_update.label", {
      date: updatedAtString
    });
    $[0] = creators;
    $[1] = teachers;
    $[2] = updatedAt;
    $[3] = T0;
    $[4] = T1;
    $[5] = T2;
    $[6] = T3;
    $[7] = t1;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    T2 = $[5];
    T3 = $[6];
    t1 = $[7];
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t15;
  if ($[38] !== T0 || $[39] !== t1 || $[40] !== t2) {
    t15 = <T0 variant={t1}>{t2}</T0>;
    $[38] = T0;
    $[39] = t1;
    $[40] = t2;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Typography variant="subheading">{translate("course.license.label")}</Typography>;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== license) {
    t17 = <Stack direction="row" alignItems="center" gap={2}>{t16}<Licenses license={license} /></Stack>;
    $[43] = license;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== T1 || $[46] !== t15 || $[47] !== t17 || $[48] !== t3 || $[49] !== t4 || $[50] !== t5) {
    t18 = <T1 direction={t3} justifyContent={t4} gap={t5}>{t15}{t17}</T1>;
    $[45] = T1;
    $[46] = t15;
    $[47] = t17;
    $[48] = t3;
    $[49] = t4;
    $[50] = t5;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== T2 || $[53] !== t18 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8 || $[57] !== t9) {
    t19 = <T2 direction={t6} gap={t7}>{t8}{t9}{t18}</T2>;
    $[52] = T2;
    $[53] = t18;
    $[54] = t6;
    $[55] = t7;
    $[56] = t8;
    $[57] = t9;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== T3 || $[60] !== t10 || $[61] !== t11 || $[62] !== t12 || $[63] !== t19) {
    t20 = <T3 gap={t10} sx={t11}>{t12}{t19}</T3>;
    $[59] = T3;
    $[60] = t10;
    $[61] = t11;
    $[62] = t12;
    $[63] = t19;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== t13 || $[66] !== t14 || $[67] !== t20) {
    t21 = <>{t13}{t14}{t20}</>;
    $[65] = t13;
    $[66] = t14;
    $[67] = t20;
    $[68] = t21;
  } else {
    t21 = $[68];
  }
  return t21;
};
export default Credits;